"use client";

import { c as _c } from "react/compiler-runtime";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import { Children, type ReactNode } from "react";
import DropCurationButton from "../DropCurationButton";
import WaveDropReactions from "../WaveDropReactions";
import { ParticipationDropRatings } from "./ParticipationDropRatings";
interface ParticipationDropFooterProps {
  readonly drop: ExtendedDrop;
  readonly voteAction?: ReactNode;
  readonly showInteractions?: boolean | undefined;
}
export default function ParticipationDropFooter(t0) {
  const $ = _c(25);
  const {
    drop,
    voteAction,
    showInteractions: t1
  } = t0;
  const showInteractions = t1 === undefined ? true : t1;
  const {
    canShowVote
  } = useDropInteractionRules(drop);
  const canShowCuration = drop.context_profile_context?.curatable ?? false;
  const hasRatings = drop.raters_count > 0;
  const hasReactions = drop.reactions.length > 0;
  let t2;
  if ($[0] !== voteAction) {
    t2 = Children.toArray(voteAction);
    $[0] = voteAction;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const normalizedVoteAction = t2;
  const hasVoteAction = normalizedVoteAction.length > 0;
  const hasPrimaryActions = canShowCuration || hasVoteAction;
  const shouldShowVoteFooter = canShowVote && (hasRatings || hasPrimaryActions);
  const shouldShowRatingsOnlyFooter = !canShowVote && hasRatings;
  const shouldShowReactionsFooter = hasReactions || !canShowVote && canShowCuration;
  if (!showInteractions) {
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="tw-pb-4" />;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    return t3;
  }
  let t3;
  if ($[3] !== canShowCuration || $[4] !== drop || $[5] !== hasPrimaryActions || $[6] !== hasRatings || $[7] !== normalizedVoteAction || $[8] !== shouldShowVoteFooter) {
    t3 = shouldShowVoteFooter && <div className="tw-mt-4 tw-@container sm:tw-ml-[3.25rem]" onClick={_temp}><div className="tw-flex tw-flex-col tw-gap-x-4 tw-gap-y-3 @[700px]:tw-flex-row @[700px]:tw-items-center @[700px]:tw-justify-between">{hasRatings && <div className="tw-px-4"><ParticipationDropRatings drop={drop} rank={drop.rank} /></div>}{hasPrimaryActions && <div className="tw-flex tw-w-full tw-items-center tw-justify-center tw-gap-1.5 tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-800 tw-px-6 tw-pt-4 @[700px]:tw-ml-auto @[700px]:tw-w-auto @[700px]:tw-border-none @[700px]:tw-px-4 @[700px]:tw-pt-0"><DropCurationButton dropId={drop.id} waveId={drop.wave.id} isCuratable={canShowCuration} isCurated={drop.context_profile_context?.curated ?? false} />{normalizedVoteAction}</div>}</div></div>;
    $[3] = canShowCuration;
    $[4] = drop;
    $[5] = hasPrimaryActions;
    $[6] = hasRatings;
    $[7] = normalizedVoteAction;
    $[8] = shouldShowVoteFooter;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== drop || $[11] !== shouldShowRatingsOnlyFooter) {
    t4 = shouldShowRatingsOnlyFooter && <div className="tw-ml-[3.25rem] tw-mt-4 tw-px-4"><ParticipationDropRatings drop={drop} rank={drop.rank} /></div>;
    $[10] = drop;
    $[11] = shouldShowRatingsOnlyFooter;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== canShowCuration || $[14] !== canShowVote || $[15] !== drop || $[16] !== shouldShowReactionsFooter) {
    t5 = shouldShowReactionsFooter && <div className="tw-ml-[3.25rem] tw-mt-4 tw-flex tw-w-[calc(100%-3.25rem)] tw-flex-wrap tw-items-center tw-gap-x-2 tw-gap-y-1 tw-px-4 tw-pb-4">{!canShowVote && <DropCurationButton dropId={drop.id} waveId={drop.wave.id} isCuratable={canShowCuration} isCurated={drop.context_profile_context?.curated ?? false} />}<WaveDropReactions drop={drop} /></div>;
    $[13] = canShowCuration;
    $[14] = canShowVote;
    $[15] = drop;
    $[16] = shouldShowReactionsFooter;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== shouldShowReactionsFooter) {
    t6 = !shouldShowReactionsFooter && <div className="tw-pb-4" />;
    $[18] = shouldShowReactionsFooter;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t3 || $[21] !== t4 || $[22] !== t5 || $[23] !== t6) {
    t7 = <>{t3}{t4}{t5}{t6}</>;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
}
function _temp(e) {
  return e.stopPropagation();
}